<template>
  <span
    v-if="maskIconSrc"
    class="icon icon--mask"
    :style="maskStyles"
    aria-hidden="true"
  />
  <svg v-else width="0" height="0" class="icon" :style="styles">
    <use :xlink:href="require('@/assets/img/icons.svg') + '#' + id"></use>
  </svg>
</template>
<script>
const MASK_ICONS = {
  'menu-imat': require('@/assets/img/ic-alloynx.png'),
  'menu-imelt': require('@/assets/img/ic-meltnx.png'),
}

export default {
  name: "Icon",
  props:
  {
    id:{
      type: String,
      default: 'menu'
    },
    size:{
      type: String,
      default: null
    },
    color:{
      type:String,
      default: null
    }
  },
  computed:{
    maskIconSrc() {
      return MASK_ICONS[this.id] || null
    },
    resolvedColor() {
      if (!this.color) return null
      return this.color === 'primary'
        ? this.$vuetify.theme.themes.light.primary
        : this.color
    },
    styles(){
      let s = ''
      if (this.size) {
        s = 'font-size:' + this.size + ';width:' + this.size + ';height:' + this.size
      }
      s += this.resolvedColor ? ';color:' + this.resolvedColor : ''
      return s
    },
    maskStyles() {
      const url = `url("${this.maskIconSrc}")`
      let s = `background-color: ${this.resolvedColor || 'currentColor'};`
      s += `-webkit-mask-image: ${url};mask-image: ${url};`
      if (this.size) {
        s += `width: ${this.size};height: ${this.size};`
      }
      return s + this.styles
    },
  }
  
}
</script>
<style scoped>
.icon {
  display: inline-block;
  height: 1em;
  width: 1em;
  vertical-align: middle;
  margin-bottom: 0.125em;
}

svg.icon {
  fill: currentColor;
}

.icon--mask {
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
}
</style>